module.exports = __webpack_public_path__ + "static/media/mondo.fced2164.jpg";